// Import necessary functions and modules
import { fetchBaseQuery, retry } from "@reduxjs/toolkit/query/react";
import { appConstants } from "helpers/constants/appConstants";
import { localStore } from "stores/localStore";
import { toastActions } from "./slices/toastSlice";
import { commonActions } from "./slices/commonSlice";
import _get from "lodash/get";
import { useHistory } from "react-router-dom";

// Create an object named apiSliceInterceptor
const apiSliceInterceptor = {};
// Configure the base query for API requests
apiSliceInterceptor.baseQuery = fetchBaseQuery({
	baseUrl: appConstants.apiBaseURL,
	prepareHeaders: (headers) => {
		const token = localStore.getToken();
		if (token) {
			headers.set("Authorization", `Bearer ${token}`);
		}
		return headers;
	},
});

apiSliceInterceptor.baseQueryWithRetry = retry(apiSliceInterceptor.baseQueryWithInterceptor, {
	maxRetries: 3,
});

apiSliceInterceptor.baseQueryWithInterceptor = async (args, api, extraOptions) => {
	try {
		let body = _get(args, "body", {});
		let params = _get(args, "params", {});

		// console.log("interceptor : ==> ", args, api, extraOptions);
		
		if(!body?.noGlobalLoading && !params?.noGlobalLoading){
			api.dispatch(commonActions.setLoading());
		}
		if(body?.noGlobalLoading){
			delete body.noGlobalLoading;
		}
		if(params?.noGlobalLoading){
			delete params.noGlobalLoading;
		}


		const result = await apiSliceInterceptor.baseQuery(args, api, extraOptions);

		api.dispatch(commonActions.resetLoading());

		if (result.error) {
			let toastMessage = "Oops, Something went wrong. Please try again later";

			if (result.error.status === 401) {
				 
					localStore.resetToken(); // Remove token
					history.replace("/"); // Navigate to login
			}

			if (result.error?.data?.message) {
				toastMessage = result.error.data.message;
			}

			api.dispatch(
				toastActions.setToastData({
					message: toastMessage,
				})
			);
		}

		console.log("result", result);
		return result;
	} catch (error) {
		toastActions.setToastData({
			message: "Oops, Something went wrong. Please try again later",
		});
		api.dispatch(commonActions.resetLoading());
		return error;
	}
};

// Export the configured apiSliceInterceptor object
export { apiSliceInterceptor };
